// extracted by mini-css-extract-plugin
module.exports = {"name":"Sidebar_name__1dEER","btnWrapper":"Sidebar_btnWrapper__1SEWK","wrapper":"Sidebar_wrapper__3DEyX","closeIcon":"Sidebar_closeIcon__14qrU"};